import { useState } from 'react';
import { Button, Modal } from '@omnitok/ui';
import { Info } from 'lucide-react';

export default function InfoButton({ title, children }: { title: string; children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  return <>
    <button type="button" className="consolidation-info" aria-label={`Información: ${title}`} onClick={() => setOpen(true)}>
      <Info size={17} aria-hidden="true" />
    </button>
    <Modal open={open} onClose={() => setOpen(false)} title={title} size="md"
      footer={<Button variant="outline" onClick={() => setOpen(false)}>Entendido</Button>}>
      <div className="consolidation-help">{children}</div>
    </Modal>
  </>;
}
